import { createAction } from '@reduxjs/toolkit';

export enum CuroActions {
  ResetStore = 'curoActions/resetStore',
}

export const resetCuroStore = createAction(CuroActions.ResetStore);
